import bbitApi from '@api/make-request'
import {
  IPathParamsArgs,
  IRepository,
  numberArgs,
} from '@api/repositories/i-repository'
import { IDistrict } from '@app/interfaces/organization/districts'
import { AxiosResponse } from 'axios'

class DistrictRepository implements IRepository<IDistrict> {
  create(data: IDistrict): Promise<AxiosResponse<IDistrict>> {
    return bbitApi.post('/dictionary/api/v1/districts', data)
  }

  getAll(args: IPathParamsArgs): Promise<AxiosResponse<IDistrict[]>> {
    return bbitApi.get('/dictionary/api/v1/districts', {
      cancelToken: args.source?.token,
    })
  }

  getOne(args: numberArgs): Promise<AxiosResponse<IDistrict>> {
    return bbitApi.get(`/dictionary/api/v1/districts/${args.data}`, {
      cancelToken: args.source?.token,
    })
  }

  update(data: IDistrict): Promise<AxiosResponse<IDistrict>> {
    return bbitApi.put(`/dictionary/api/v1/districts/${data.id}`, data)
  }
}

export default new DistrictRepository()
